import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit, ViewChildren, QueryList,
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {forkJoin, Observable, Observer} from 'rxjs';
import {getCookie} from '../../../utilities/cookie.utilities';
import {PricingService} from '../../../../pricing/services/pricing.service';
import {UsersService} from '../../../services/users.service';
import {DiscountViewModel, PricingAmountViewModel, PricingViewModel} from '../../../../pricing/viewModels/pricing.viewModel';
import {AppLoadingEventsEmitter} from '../../../events/loading.events';
import {LocalisationService} from '../../../services/localisation.service';
import {Router} from '@angular/router';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-upgrade',
    templateUrl: './upgrade.component.html',
    styleUrls: ['./upgrade.component.scss']
})
export class UpgradeComponent implements OnInit, AfterViewInit {
    private readonly mobileWidth: number = 576;

    pricings: PricingViewModel[] = null;
    currentUserIsReferral = false;
    discountCode: DiscountViewModel = null;
    showYearlyPricing = false;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    @ViewChildren('activeCheck') activeChecks: QueryList<NgbTooltip>;

    masterProfile = false;

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly pricingService: PricingService,
        private readonly usersService: UsersService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly localisationService: LocalisationService,
        private readonly router: Router
    ) {
    }

    ngOnInit() {
        this.masterProfile = (this.usersService.userProfile && this.usersService.userProfile.is_master_profile === true);

        this.load().subscribe();
    }

    getPricing(): PricingViewModel {
        if (this.pricings !== null && this.pricings.length > 0) {
            return this.pricings[0];
        }

        return null;
    }

    private load(): Observable<boolean> {
        return new Observable((observer: Observer<boolean>) => {
            forkJoin([
                this.pricingService.getPricings(),
                this.pricingService.getPaymentMethods()
            ]).subscribe(([pricings, paymentMethods]) => {
                const new_pricings = pricings.filter(pricing => pricing.show_for_master_profiles === this.masterProfile);

                this.pricings = new_pricings.sort((a, b) => +a.amounts[0].monthly_price - +b.amounts[0].monthly_price);
                this.currentUserIsReferral = false;

                // detect discount cookie
                const discountCookie = getCookie('discount');

                if (!(discountCookie === null || discountCookie.length <= 0)) {
                    this.applyDiscountForAllPlans(discountCookie);
                }

                this.pricings = this.pricings.filter(pricing => parseFloat(pricing.amounts[0].monthly_price) > 0);

                observer.next(true);
                observer.complete();
            });
        });
    }

    private applyDiscountForAllPlans(discountCode: string) {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.pricingService.getDiscount({'discount_code': discountCode}).subscribe(discount => {
            this.discountCode = discount;

            // tslint:disable-next-line:forin
            for (const pricingIndex in this.pricings) {

                // tslint:disable-next-line:forin
                for (const amountIndex in this.pricings[pricingIndex].amounts) {
                    // @ts-ignore
                    if (this.pricings[pricingIndex].amounts[amountIndex].monthly_price <= 0) {
                        continue;
                    }

                    // @ts-ignore
                    this.pricings[pricingIndex].amounts[amountIndex].monthly_price = (this.pricings[pricingIndex].amounts[amountIndex].monthly_price - (this.pricings[pricingIndex].amounts[amountIndex].monthly_price * (this.getDiscountPercentageByLocale(this.discountCode) / 100))).toFixed(2);
                }
            }

            this.pricings = this.pricings.sort((a, b) => +a.amounts[0].monthly_price - +b.amounts[0].monthly_price);
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        }, () => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        } else {
            this.defaultScreen();
        }

        this.openAllTooltips();
    }

    getLanguagePricingAmount(pricing: PricingViewModel): PricingAmountViewModel {
        const language = this.localisationService.getLanguage();

        for (const amountIndex in pricing.amounts) {
            if (pricing.amounts[amountIndex].language.country_code === language) {
                // @ts-ignore
                return pricing.amounts[amountIndex];
            }
        }

        return null;
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    private defaultScreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        // modalDialog.style.display = 'flex';
        // modalDialog.style.margin = '0';
        // modalDialog.style.padding = '0';
        // modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = '564px';
        // modalDialog.style.minHeight = '100%';
        // modalDialog.style.height = '100%';
        // modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    onChoose() {
        this.router.navigate(['pricing']);
        this.bsModalRef.hide();
    }

    private openAllTooltips(disable_delay: boolean = false) {
        const _this = this;
        setTimeout(function () {
            _this.activeChecks.forEach((tooltip) => {
                tooltip.open();
            });
        }, (disable_delay === true ? 100 : 1100));
    }

    onYearlyPricingToggleChange(custom_value = null) {
        if (custom_value !== null) {
            this.showYearlyPricing = custom_value;
        } else {
            this.showYearlyPricing = !this.showYearlyPricing;
        }

        this.openAllTooltips(true);
    }
}
